import { render, staticRenderFns } from "./StoryEvent.vue?vue&type=template&id=2e522ef0&scoped=true&"
import script from "./StoryEvent.vue?vue&type=script&lang=js&"
export * from "./StoryEvent.vue?vue&type=script&lang=js&"
import style0 from "./StoryEvent.vue?vue&type=style&index=0&id=2e522ef0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e522ef0",
  null
  
)

export default component.exports